<template>
  <div id="Debtor" dir="rtl">
    <loading v-if="loadingRender"></loading>
    <panel Title="فرم برداشت وجه" Des="از طریق این فرم می توانید درخواست برداشت وجه خودرا اعلام کنید" :IsBtnBack="true" :IsBtnClose="false" ClassCustom="bg-dark-Custom text-right"></panel>
    <div class="row">
      <div class="col-1"></div>
      <div class="col-md-10 col-12">
        <div class="card Netpa-Shadow p-3 text-right">
          <div class="row">
            <div class="col-md-2 col-12"></div>
            <div class="col-md-8 col-12">
              <div class="row">
                <div class="col-8">
                  <div v-if="!TaahodatId && !GhebelBardasht">
                    <small>انتخاب حساب</small>
                    <select v-if="IsLoad" name="cmbTaahodat" id="cmbTaahodat" class="form-control Pointer" v-model="Resultcmb">
                      <option v-if="this.IsLoad == false" value="-2">|| در حال بارگذاری ، منتظر بمانید ... ||</option>
                      <option selected value="-1">-- انتخاب حساب --</option>
                      <option v-for="item in this.ListModel" :key="item.id" :value="item">
                        <span>{{ item.vcodeDesNo }} </span>
                        <span>{{ item.nameFamily }} </span>
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-4 pt-4 pr-2">قابل برداشت: {{ Resultcmb ? $Comma3ragham(Resultcmb.ghabelBardasht + Resultcmb.sumMabTaeedNaShode) : '' }}</div>
              </div>

              <div class="mt-3">
                <span>مبـــلغ برداشت</span>
                <input ref="txtMablagh" id="txtMablagh" tabindex="1" class="form-control 3ragham text-center" style="font-size: 15px !important" v-model="MabBardasht" />
              </div>
              <div class="mt-3 text-center">
                <span class="d-block text-dark font-weight-bold" style="font-size: 14px !important">{{ Mab2persian }}</span>
              </div>

              <article v-if="$session.get('CustCode') != 801">
                <div class="mt-2">
                  <div class="radio">
                    <input v-if="$session.get('CustCode') != 561" label="انتقال به کارت" type="radio" name="NoeEnteghal" value="Card" checked="NoeEnteghal == 'Card'" v-model="NoeEnteghal" />
                    <input label="انتقال به شبا" type="radio" name="NoeEnteghal" value="Sheba" checked="NoeEnteghal == 'Sheba'" v-model="NoeEnteghal" />
                  </div>
                </div>
                <div class="mt-2 container" v-if="NoeEnteghal == 'Card'">
                  <small>شماره کارت: </small>

                  <div class="row px-5" dir="ltr">
                    <div class="col-3 px-3">
                      <input type="number" class="form-control text-center" id="FirstInput" @input="First4Digit.length > 4 ? ((First4Digit = First4Digit.slice(0, 4)), jumpTo('SecondInput')) : void 0" v-model="First4Digit" />
                    </div>
                    <div class="col-3 px-3">
                      <input type="number" class="form-control text-center" id="SecondInput" @input="Second4Digit.length > 4 ? ((Second4Digit = Second4Digit.slice(0, 4)), jumpTo('ThirdInput')) : void 0" v-model="Second4Digit" />
                    </div>
                    <div class="col-3 px-3">
                      <input type="number" class="form-control text-center" id="ThirdInput" @input="Third4Digit.length > 4 ? ((Third4Digit = Third4Digit.slice(0, 4)), jumpTo('lastInput')) : void 0" v-model="Third4Digit" />
                    </div>
                    <div class="col-3 px-3">
                      <input type="number" class="form-control text-center" id="lastInput" @input="Forth4Digit.length > 4 ? ((Forth4Digit = Forth4Digit.slice(0, 4)), jumpTo('NameSahebHesab')) : void 0" v-model="Forth4Digit" />
                    </div>
                  </div>
                </div>
                <div class="mt-2 container" v-if="NoeEnteghal == 'Sheba'">
                  <div class="row" dir="ltr">
                    <div class="col-1">
                      <small class="mt-4" style="font-size: 1.7rem; white-space: nowrap">IR</small>
                    </div>
                    <div class="col-11">
                      <input type="number" @input="ShebaNo.length > 24 ? ((ShebaNo = ShebaNo.slice(0, 24)), jumpTo('NameSahebHesab')) : void 0" class="form-control" v-model="ShebaNo" />
                    </div>
                  </div>
                </div>
                <div class="mt-4">
                  <div class="row">
                    <div class="col-md-3 col-12"></div>
                    <div class="col-md-6 col-12">
                      <small>نام صاحب حساب</small>
                      <input id="NameSahebHesab" type="text" v-model="NameSahebHesab" class="form-control" />
                    </div>
                    <div class="col-md-3 col-12"></div>
                  </div>
                </div>
              </article>
              <div class="mt-5 text-center">
                <button class="btn btn-danger w-75" style="font-size: 14px !important" @click="SabtBardasht(TaahodatId)">
                  {{ GetMablagh }}
                </button>
                <button id="CloseModal" class="btn btn-danger w-75 d-none" style="font-size: 14px !important" data-dismiss="modal"></button>
              </div>
            </div>
            <div class="col-md-2 col-12"></div>
          </div>
        </div>
      </div>
      <div class="col-1"></div>
    </div>
  </div>
</template>
<script>
import Num2persian from 'num2persian'
import Panel from '../Tools/NetPa/Panel.vue'
import loading from '../Tools/NetPa/Loading.vue'
export default {
  data() {
    return {
      First4Digit: '',
      Second4Digit: '',
      Third4Digit: '',
      Forth4Digit: '',
      MabBardasht: '',
      NameSahebHesab: '',
      BankName: '',
      ShebaNo: null,
      CardNo: null,
      NoeEnteghal: 'Sheba',
      DataAxios: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'EnteghalVajh',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_cmbTaahodat: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat/TaahodatSahebHesab',
        Token: this.$session.get('TokenNetPa'),
      },
      IsLoad: false,
      Resultcmb: null,
      rows: [],
      columns: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'ردیف',
          name: 'row',
        },

        {
          label: 'عنوان حساب',
          name: 'DesNoe',
        },
        {
          label: 'کد حساب',
          name: 'VCode',
        },
        {
          label: 'مبلغ برداشت',
          name: 'Bestan',
        },
        {
          label: 'زمان تراکنش',
          name: 'ZamanInsert',
        },
        {
          label: 'تاریخ سند',
          name: 'TarixSanad',
        },
        {
          label: 'کد رهگیری',
          name: 'CodeRahgiri',
        },
        {
          label: 'شرح برداشت',
          name: 'SharhSanad',
        },
      ],
      config: {
        pagination: true,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: '',
        card_mode: false,
        global_search: {
          placeholder: ' جستجو',
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: 'table-bordered table-striped table-sm ',
      },
      loadingRender: false,
      ListModel: null,
      ListModelSahebHesab: null,
    }
  },
  components: {
    Panel,
    loading,
  },
  props: ['TaahodatId', 'GhebelBardasht'],
  updated() {
    this.$PutCommatoInput()
  },
  computed: {
    Mab2persian() {
      var Mab = this.MabBardasht.replace(/,/g, '')
      Mab = this.$b_ToPersianNumber(Mab)
      return ' مبلـغ ' + Num2persian(Mab) + ' ریال '
    },
    GetMablagh() {
      var Mab = this.MabBardasht.replace(/,/g, '')
      Mab = this.$b_ToPersianNumber(Mab)
      return ' برداشــت ' + this.$Comma3ragham(Mab) + ' ریال '
    },
  },
  methods: {
    SabtBardasht(id) {
      if (this.$session.get('CustCode') != 801) {
        if (this.NoeEnteghal == 'Card') {
          this.ShebaNo = ''
          this.CardNo = this.First4Digit + this.Second4Digit + this.Third4Digit + this.Forth4Digit
          if (this.CardNo.length != 16) {
            this.$mySweetDefault('خطا', 'شماره کارت صحیح نمیباشد', 'error', 2500)
            return
          }
        } else {
          this.CardNo = ''
          if (this.ShebaNo.length != 24) {
            this.$mySweetDefault('خطا', 'شماره شبا صحیح نمیباشد', 'error', 2500)
            return
          }
        }
        if (this.NameSahebHesab.length < 1) {
          this.$mySweetDefault('خطا', 'نام صاحب حساب وارد نشده است', 'error', 2500)
          return
        }
      }
      if (Number(this.MabBardasht.replace(/,/g, '')) <= this.Resultcmb.ghabelBardasht + this.Resultcmb.sumMabTaeedNaShode) {
        this.loadingRender = true
        var Mablagh = this.MabBardasht.replace(/,/g, '')
        var NameSahebHesab = this.$session.get('UserInfoNetPa').ozvName + ' ' + this.$session.get('UserInfoNetPa').ozvFamily
        const formData = new FormData()
        formData.append('wwwtblTaahodatIdBestanKar', 0)
        formData.append('wwwtblTaahodatIdBedehKar', id ? id : this.Resultcmb.id)
        formData.append('Mablagh', Mablagh)
        formData.append('Desc', 'درخواست برداشت از حساب')
        formData.append('KodRahgiri', '')
        formData.append('CardNo', this.$session.get('CustCode') != 801 ? this.CardNo : '')
        formData.append('ShebaNo', this.$session.get('CustCode') != 801 ? this.ShebaNo : '')
        formData.append('NameSahebHesab', this.$session.get('CustCode') != 801 ? this.NameSahebHesab : NameSahebHesab)
        formData.append('EnteghalNoe', 6)
        formData.append('HesabNo', '')
        formData.append('OrderId', '-2')
        formData.append('MabKarmozdEnteghal', 0)
        formData.append('MabKarmozdBnp', 0)
        formData.append('BankName', this.$session.get('CustCode') != 801 ? this.BankName : '')
        formData.append('ComboIdGrp324', '')
        formData.append('TarixSanad', this.$store.state.JalaliDate)
        this.DataAxios.ArryfildValue = formData
        this.$PostFormData(this.DataAxios).then((data) => {
          if (data.success === 'SUCCESS') {
            document.getElementById('CloseModal').click()
            this.$mySweetDefault('درخواست موفقیت آمیز', 'درخواست برداشت با موفقیت انجام شد ، کد رهگیری شما :' + data.codeRahgiri, 'success', 7000)
            this.loadingRender = false
            this.$router.push({ name: 'DebtorReport', params: null })
            // checkIn
          } else {
            this.loadingRender = false
            this.$mySweetDefaultTost('خطا', 'در برداشت از حساب مشکلی پیش آمده لطفا مجددا تلاش کنید', 'warning', 2000)
          }
        })
      } else {
        this.$mySweetDefaultTost('خطا', 'مبلغ برداشت نمیتواند بیشتر از مبلغ قابل برداشت باشد حساب باشید', 'warning', 2000)
        return
      }
    },
    jumpTo(id) {
      document.getElementById(id).focus()
    },
  },
  mounted() {
    // this.$refs.txtMablagh.focus()
    const formData = new FormData()
    let info
    formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
    formData.append('wwwtblSarfaslTypeId', 2)
    this.DataAxios_cmbTaahodat.ArryfildValue = formData
    this.$PostFormData(this.DataAxios_cmbTaahodat)
      .then((data) => {
        this.IsLoad = true
        this.ListModel = data.filter((x) => x.tblSarfaslTypeId != 6)
        this.Resultcmb = data[0]
      })
      .finally(() => {
        const formData = new FormData()
        formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
        formData.append('wwwtblSarfaslTypeId', 2)
        this.DataAxios_SahebHesab.ArryfildValue = formData
        this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
          if (data.length > 0) {
            this.IsLoad = true
            this.ListModelSahebHesab = data
            for (let index = 0; index < this.ListModelSahebHesab.length; index++) {
              if (this.ListModelSahebHesab[index].mande > 0) {
                info = this.ListModelSahebHesab[index]
                this.ListModel.push(info)
              }
            }
          }
          if (this.TaahodatId) {
            this.ListModel.forEach((e) => {
              if (e.id == this.TaahodatId) {
                this.Resultcmb = e
              }
            })
          }
        })
      })
  },
}
</script>
<style scoped>
.card {
  border-radius: 15px !important;
}

.radio {
  padding: 4px;
  text-align: center;
  position: relative;
}

.radio input {
  width: auto;
  height: 100%;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  cursor: pointer;
  border-radius: 2px;
  padding: 4px 8px;
  color: #bdbdbdbd;
  font-size: 14px;
  transition: all 100ms linear;
}

.radio input {
  color: #000 !important;
}
.radio input:checked {
  background-image: linear-gradient(180deg, #435ebe, #5770c9);
  color: #fff !important;
  box-shadow: 0 1px 1px #0000002e;
  text-shadow: 0 1px 0px #79485f7a;
}

.radio input:before {
  content: attr(label);
  display: inline-block;
  text-align: center;
  width: 100%;
}
</style>
